import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  linksListRequest: [],
  linksListSuccess: ['listData'],
  linksListFailure: ['listError'],

  linksCreateRequest: ['createParams'],
  linksCreateSuccess: ['createData'],
  linksCreateFailure: ['createError']
})

export const LinkTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  listData: [],
  listFetching: null,
  listError: null,

  createData: [],
  createFetching: [],
  createError: []
})

/* ------------- Reducers ------------- */

export const listRequest = (state) =>
  state.merge({ listFetching: true, listError: null })

export const listSuccess = (state, { listData }) =>
  state.merge({ listFetching: false, listData })

export const listFailure = (state, { listError }) =>
  state.merge({ listFetching: false, listError })

export const createRequest = (state) =>
  state.merge({ createFetching: true, createError: null })

export const createSuccess = (state, { createData }) =>
  state.merge({ createFetching: false, createData })

export const createFailure = (state, { createError }) =>
  state.merge({ createFetching: false, createError })

export const reset = (state) => state.merge(INITIAL_STATE)

/* ------------- Selectors ------------- */

export const LinkSelectors = {
  linksList: state => state.links.listData
}

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.LINKS_LIST_REQUEST]: listRequest,
  [Types.LINKS_LIST_SUCCESS]: listSuccess,
  [Types.LINKS_LIST_FAILURE]: listFailure,

  [Types.LINKS_CREATE_REQUEST]: createRequest,
  [Types.LINKS_CREATE_SUCCESS]: createSuccess,
  [Types.LINKS_CREATE_FAILURE]: createFailure
})



// WEBPACK FOOTER //
// ./src/Redux/LinkRedux.js